import objectFitImages from 'object-fit-images';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

objectFitImages();

const sliders = [...document.querySelectorAll( '.hero--slider' )];
const videos = [...document.querySelectorAll( '.hero--video' )];
const images = [...document.querySelectorAll( '.hero--image' )];

const config = {
  cellAlign: 'left',
  wrapAround: true,
  prevNextButtons: false,
  imagesLoaded: true,
  contain: true,
  pageDots: true,
  selectedAttraction: 0.05,
  friction: 0.5,
  dragThreshold: 5,
  autoPlay: 3000,
};

const headerOffset = document.getElementById( 'header' ).offsetHeight - 20;


function getHeaderOffset() {
  return document.getElementById( 'header' ).offsetHeight - 20;
}

function stopVerticalScroll( el ) {
  el.on( 'dragStart', () => {
    document.ontouchmove = e => e.preventDefault();
  } );
  el.on( 'dragEnd', () => {
    document.ontouchmove = () => true;
  } );
}

function init() {
  if ( sliders.length ) {
    // Manually set-up the 1st Slider height to consume the height of screen
    sliders[0].parentElement.setAttribute( 'style', `height: calc( 100vh - ${getHeaderOffset()}px ); min-height: 500px;` );
    sliders.forEach( ( slider ) => {
      const s = new Flickity( slider, config );
      stopVerticalScroll( s );
    } );
  }
  if ( videos.length ) {
    // Manually set-up the 1st Video height to consume the height of screen
    videos[0].parentElement.setAttribute( 'style', `min-height: calc( 100vh - ${getHeaderOffset()}px )` );
  }
  if ( images.length ) {
    // Manually set-up the 1st Image height to consume the height of screen
    images[0].parentElement.setAttribute( 'style', `min-height: calc( 100vh - ${getHeaderOffset()}px )` );
  }

  // Handle Scrolling Past Hero
  const triggerScroll = document.querySelector( '.scrollToBottomOfParentEl' );
  if ( triggerScroll ) {
      triggerScroll.addEventListener( 'click', function ( e ) {
        const scrollDistance = this.parentElement.offsetHeight + headerOffset;
        e.preventDefault();
        if ( e.target.className === 'scroll-trigger' ) {
          window.scrollTo( {
            top: scrollDistance,
            left: 0,
            behavior: 'smooth',
          } );
        }
      } );
  }
}

export default {
  init,
};
